export default {
  system: 'JOYSON IMS Management',
  lang: 'en',
  //基础
  base: {
    search: 'Search',
    query: 'Query',
    clear: 'Clear',
    open: 'Open',
    close: 'Close',
    add: 'Add',
    detail: 'Detail',
    update: 'Update',
    delete: 'Delete',
    remove: 'Remove',
    save: 'Save',
    empty: 'Empty',
    confirm: 'Confirm',
    cancel: 'Cancel',
    role: 'Role',
    user: 'User',
    auth: 'Auth',
    system: 'System',
    group: 'Group',
    page: 'Page',
    name: 'Name',
    phone: 'Phone',
    email: 'E-mail',
    account: 'Account',
    empNumber: 'Emp Number',
    baseinfo: 'Base Info',
    personal: 'Personal',
    loadFailed: 'Load failed',
    datalist: 'Data List',
    treelist: 'Tree List',
    emptydata: 'No Data',
    memberManage: 'Member Manage',
    authAssign: 'Auth Assign',
    roleAssign: 'Role Assign',
    changePassword: 'ChangePassword',
    oldPassword: 'oldPassword',
    newPassword: 'newPassword',
    export: 'Export',
    operation: 'operation',
    ifEnable: 'ifEnable',
    Enable: 'Enable',
    Disable: 'Disable',
    exit: 'EXIT',
    PleaseSelect: 'Please Select',
    PleaseEnter: 'Please Enter',
    SuccessfullyAdded: 'Successfully Added!!!',
    SuccessfullyUpdated: 'Successfully Updated!!!',
    order: 'order',
    Reset: 'Reset',
    Mould: 'Mould',
    Import: 'Import',
    ImportSucceeded: 'Import Succeeded',
    JobNo: 'JobNo',
  },
  //机构
  mechanism: {
    mechanismList: 'MechanismList',
    Organization: 'organization',
    factoryDomain: 'factoryDomain',
    factoryCode: 'factoryCode',
    factoryAddress: 'factoryAddress',
    factoryID: 'factoryID',
    shopCode: 'shopCode',
    shopName: 'shopName',
    sectionCode: 'sectionCode',
    sectionName: 'sectionName',
    lineCode: 'lineCode',
    lineName: 'lineName',
    SAPLineCode: 'SAPLineCode',
    AddShop: 'AddShop',
    AddSection: 'AddSection',
    AddLine: 'AddLine',
    UpdateShop: 'UpdateShop',
    UpdateSection: 'UpdateSection',
    UpdateLine: 'UpdateLine',
    selectFc: 'Please select a factory first',
    mechanismInfo: 'mechanismInfo',
  },
  //班次
  Shift: {
    ShiftList: 'ShiftList',
    factory: 'factory',
    ShiftCode: 'ShiftCode',
    Shift: 'Shift',
    startTime: 'startTime',
    endTime: 'endTime',
    scShift: 'shift',
    HH: '（HH）',
    mm: '（mm）',
    ShiftInfo: 'ShiftInfo',
  },
  //部门
  Branch: {
    BranchCode: 'BranchCode',
    BranchName: 'BranchName',
    BranchList: 'BranchList',
  },
  //科室
  Department: {
    DepartmentCode: 'DepartmentCode',
    DepartmentName: 'DepartmentName',
    DepartmentList: 'DepartmentList',
    DepartmentImport: 'DepartmentImport',
  },
  //员工
  Staff: {
    Staffid: 'Staffid',
    StaffName: 'StaffName',
    StaffList: 'StaffList',
    AddStaff: 'AddStaff',
    duty: 'duty',
    AppointForeman: 'AppointForeman',
    CancelForeman: 'CancelForeman',
    Foreman: 'Foreman',
    selectStaff: 'Please select at least one staff',
    isTips: 'Are you sure to appoint the foreman? Do you want to continue?',
    notTips: 'Are you sure to step down as the foreman? Do you want to continue?',
  },
  //用户
  User: {
    state: 'state',
    WeChat: 'Whether to bind enterprise WeChat',
    UserList: 'UserList',
    Yes: 'Yes',
    No: 'No',
    UserImport: 'UserImport',
    Tips: 'Are you sure you want to reset the data and continue?',
    noWX: 'This user has not registered enterprise WeChat',
    input: 'Please enter (required)',
    select: 'Please select (required)',
    AddRole: 'AddRole',
    RoleName: 'RoleName',
    workshop: 'workshop',
    section: 'section',
    productLine: 'productLine',
    RoleLevel: 'RoleLevel',
    name: 'Please enter your name!!!',
    JobNo: 'Please enter the job number!!!',
    create: 'Create at least one role',
    added: 'This role has been added',
    gcLevel: 'Factory Level',
    cjLevel: 'Workshop Level',
    gdLevel: 'Section Level',
    cxLevel: 'productLine Level',
    UserInfo: 'UserInfo',
  },
  //角色
  Role: {
    RoleCode: 'RoleCode',
    createTime: 'createTime',
    RoleList: 'RoleList',
    RoleEdit: 'Edit the permission of the lamp role',
    Submit: 'Submit',
    select: 'Please select the lamp installation object!!!',
    RoleInfo: 'RoleInfo',
  },
  //枚举类型
  EnumType: {
    EnumType: 'EnumType',
    code: 'code',
    DeviceFiles: 'DeviceFiles',
    ToolStatus: 'ToolStatus',
    type: 'type',
  },
  //备件管理
  Account: {
    spareSort: 'spareSort',
    unit: 'unit',
    sort: 'sort',
    spareName: 'spareName',
    spareCode: 'spareCode',
    spareBrand: 'spareBrand',
    spareModel: 'spareModel',
    remark: 'remark',
    spareSortName: 'spareSortName',
    safetyStock: 'safetyStock',
    currentStock: 'currentStock',
    stockCeil: 'stockCeil',
    currentState: 'currentState',
    stockState: 'stockState',
    price: 'price',
    supplierCode: 'supplierCode',
    supplierName: 'supplierName',
    spareImport: 'spareImport',
    spareInfo: 'spareInfo',
    CostCenter: 'costCenter',
    annex: 'annex',
    spareRecord: 'spareRecord',
    operationLog: 'operationLog',
    operator: 'operator',
    operationTime: 'operationTime',
    operationType: 'operationType',
    operationDesc: 'operationDesc',
    storeName: 'storeName',
    storeCode: 'storeCode',
    storeManage: 'storeManage',
    region: 'region',
    storeInfo: 'storeInfo',
    locatorCode: 'locatorCode',
    locatorList: 'locatorList',
    locatorUniqueCode: 'locatorUniqueCode',
    locatorName: 'locatorName',
    batchNo: 'batchNo',
    allot: 'allot',
    nowBatchNo: 'nowBatchNo',
    nowLocatorNum: 'nowLocatorNum',
    allotNum: 'allotNum',
    nowLocator: 'nowLocator',
    Transfer: 'Transfer quantity cannot be greater than current inventory!',
    kwbnxt: 'Warehouse location cannot be the same!',
    tbcg: 'allot succeeded!',
    SpareStockInfo: 'SpareStockInfo',
    spareOrder: 'spareOrder',
    Finish: 'Finish',
    Purchase: 'Purchase',
    waringTime: 'waringTime',
    arrivalTime: 'arrivalTime',
    purchaseOrderCode: 'purchaseOrderCode',
    unselected: 'unselected',
    selected: 'selected',
    enter: 'Please enter the number (case sensitive)',
    specify: 'Please specify the purchase status',
    selectCk: 'Please select a store!',
    receiptType: 'receiptType',
    receiptCode: 'receiptCode',
    receiptTime: 'receiptTime',
    receiptInfo: 'receiptInfo',
    preparedBy: 'preparedBy',
    number: 'number',
    totalPrice: 'totalPrice',
    receiptRecord: 'receiptRecord',
    startTime: 'startTime',
    endTime: 'endTime',
    system: 'Automatically generated by the system',
    RMB: 'RMB',
    receiptNum: 'receiptNum',
    useType: 'useType',
    useCode: 'useCode',
    deliveryCode: 'deliveryCode',
    deliveryTime: 'deliveryTime',
    deliveryInfo: 'deliveryInfo',
    deliveryType: 'deliveryType',
    deliveryNum: 'deliveryNum',
    deliveryRecord: 'deliveryRecord',
    recipient: 'recipient',
    lampCode: 'lampCode',
    planMaintenanceCode: 'planMaintenanceCode',
  },
  //菜单
  menu: {
    person: 'Person',
    MasterData: 'MasterData',
    ChangeInfo: 'ChangeInfo',
    Password: 'Password cannot be less than 6 digits',
    empty: 'Password cannot be empty!',
    Scan: ' Scan code or not',
  },
  //提示语句
  msg: {
    cleared: 'Cleared',
    successful: 'Operation successful',
    pleaseSelectTheRoleOnTheLeft: 'Please select the content on the left',
    accountorpasswordemty: 'Account password cannot be empty',
    Tips: 'Tips',
    TipsText: 'Are you sure to delete this data? Do you want to continue?',
    cancel: 'Deletion cancelled',
    canceled: 'Operation canceled',
    Drag: 'Drag the file here, or',
    Upload: 'Click Upload',
    longTips: 'Are you sure you want to delete this department and the department information of the employees in this department will be cleared at the same time? Do you want to continue?',
    DeletionSucceeded: 'Delete Succeeded',
    DeleteFailed: 'Delete Failed',
    max: 'The size of the uploaded file cannot exceed 5MB!',
    zero: 'Quantity cannot be zero!',
    spare: 'Please select spare parts!',
    locator: 'Please select locator!',
    same: 'Spare parts cannot have the same warehouse location and batch number!',
    receipt: 'Please add the warehousing order!',
    noStock: 'Do you want to add the spare parts that are not in stock?',
    empty: 'Current inventory is empty, please select another location!',
    greater: 'The issue quantity cannot be greater than the current inventory!',
    delivery: 'Please add the delivery order!',
  },
  //以下为demo案例======================
  demo: {
    //菜单
    menu: {
      //表格
      HomePage: 'HomePage',
      MasterData: 'MasterData',
      Mechanism: 'Mechanism',
      Shift: 'Shift',
      Branch: 'Branch',
      Department: 'Department',
      User: 'User',
      Role: 'Role',
      EnumType: 'EnumType',
      Personal: 'Personal',
      Process: 'Process',
      Staff: 'Staff',
      AddUser: 'AddUser',
      EditUser: 'EditUser',
      AllLog: 'AllLog',
      SpareParts: 'SpareParts',
      SpareAccount: 'SpareAccount',
      SpareType: 'SpareType',
      SpareStore: 'SpareStore',
      SpareStock: 'SpareStock',
      SparePurchase: 'SparePurchase',
      SpareWarehouse: 'SpareWarehouse',
      SpareIssue: 'SpareIssue',
      SpareRecord: 'SpareRecord',
      SpareLocation: 'SpareLocation',
      SpareEdit: 'EditSpare',
      AddReceiptOrder: 'AddReceiptOrder',
      AddDeliveryOrder: 'AddDeliveryOrder',
      factorySparePart: 'factorySparePart',
    },
  },
}
